'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx dom */


var propTypes = {
	active: {
		type: 'number'
	},
	data: {
		type: 'array'
	},
	depth: {
		type: 'number'
	},
	vertical: {
		type: 'boolean'
	}
};

var getChildren = function getChildren(arr, _ref) {
	var active = _ref.active,
	    depth = _ref.depth,
	    onClick = _ref.onClick,
	    vertical = _ref.vertical;

	var classes = {
		'Nav': true,
		'Nav--vertical': vertical
	};

	return (0, _magicVirtualElement2.default)(
		'ul',
		{ 'class': classes },
		getItems(arr, { active: active, depth: depth, onClick: onClick, vertical: vertical })
	);
};

var getItems = function getItems(arr, _ref2) {
	var active = _ref2.active,
	    depth = _ref2.depth,
	    onClick = _ref2.onClick,
	    vertical = _ref2.vertical;

	return arr.map(function (x) {
		if (x.hidden_flg || x.level > depth) {
			return null;
		}

		var classes = _defineProperty({
			'Nav-item': true,
			'Nav-item--active': x.cat_id === active
		}, 'Nav-item--level' + x.level, true);

		return (0, _magicVirtualElement2.default)(
			'li',
			{ key: x.cat_id, 'class': classes },
			(0, _magicVirtualElement2.default)(
				'a',
				{ href: '/' + x.link_friendly_name, onClick: onClick },
				x.catname
			),
			x.children && getChildren(x.children, { active: active, depth: depth, onClick: onClick, vertical: vertical })
		);
	});
};

var render = function render(_ref3) {
	var props = _ref3.props;
	var active = props.active,
	    data = props.data,
	    depth = props.depth,
	    onClick = props.onClick,
	    vertical = props.vertical;

	var classes = {
		'Nav': true,
		'Nav--vertical': vertical
	};

	return (0, _magicVirtualElement2.default)(
		'ul',
		{ 'class': [classes, props.class] },
		getItems(data, { active: active, depth: depth, onClick: onClick, vertical: vertical })
	);
};

exports.default = { propTypes: propTypes, render: render };